/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOwnFundDto } from '../../models/backend-own-fund-dto';
import { BackendOwnFundRequestDto } from '../../models/backend-own-fund-request-dto';

export interface FinancingSourcesOwnFundsCreate$XWwwFormUrlencoded$Params {
  body: BackendOwnFundRequestDto;
}

export function financingSourcesOwnFundsCreate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesOwnFundsCreate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendOwnFundDto>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesOwnFundsCreate$XWwwFormUrlencoded.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendOwnFundDto>;
    }),
  );
}

financingSourcesOwnFundsCreate$XWwwFormUrlencoded.PATH = '/api/financing_sources/own_funds/';
